import { defineMessages } from "react-intl";

export const FormPageText = defineMessages({
  passcodeTitle: {
    defaultMessage: "A Passcode is required to view this shared view",
    id: "0qeSuE",
  },
  notFoundTitle: {
    defaultMessage: "Not Found | SmartSuite",
    id: "7sKnVQ",
  },
  enterPasscodeTitle: {
    defaultMessage: "Enter Passcode | SmartSuite",
    id: "Mrbm6d",
  },
  defaultTitle: {
    defaultMessage: "Form | SmartSuite",
    id: "cshEKS",
  },
});
